<template>
	<div>
		<div class="content" id="basic-usage">
			<p>
				For a basic use, just set the <code>items</code> and columns you want to view.<br>
				The <code>prop</code> property indicates which field of the object should be shown in a related column.
			</p>
			<pre v-highlightjs class="box pa-0"><code class="html">&lt;ui-table :items=&quot;items&quot;&gt;
	&lt;ui-table-column prop=&quot;id&quot;/&gt;
	&lt;ui-table-column prop=&quot;title&quot;/&gt;
	&lt;ui-table-column prop=&quot;body&quot;/&gt;
&lt;/ui-table&gt;</code></pre>
			<pre v-highlightjs class="box pa-0"><code class="javascript">export default {
	data() {
		return {
			items: [
				{
					&quot;userId&quot;: 1,
					&quot;id&quot;: 1,
					&quot;title&quot;: &quot;sunt aut facere repellat provident occaecati excepturi optio reprehenderit&quot;,
					&quot;body&quot;: &quot;quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto&quot;
				},
				{
					&quot;userId&quot;: 1,
					&quot;id&quot;: 2,
					&quot;title&quot;: &quot;qui est esse&quot;,
					&quot;body&quot;: &quot;est rerum tempore vitae\nsequi sint nihil reprehenderit dolor beatae ea dolores neque\nfugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis\nqui aperiam non debitis possimus qui neque nisi nulla&quot;
				},
				{
					&quot;userId&quot;: 1,
					&quot;id&quot;: 3,
					&quot;title&quot;: &quot;ea molestias quasi exercitationem repellat qui ipsa sit aut&quot;,
					&quot;body&quot;: &quot;et iusto sed quo iure\nvoluptatem occaecati omnis eligendi aut ad\nvoluptatem doloribus vel accusantium quis pariatur\nmolestiae porro eius odio et labore et velit aut&quot;
				},
				{
					&quot;userId&quot;: 1,
					&quot;id&quot;: 4,
					&quot;title&quot;: &quot;eum et est occaecati&quot;,
					&quot;body&quot;: &quot;ullam et saepe reiciendis voluptatem adipisci\nsit amet autem assumenda provident rerum culpa\nquis hic commodi nesciunt rem tenetur doloremque ipsam iure\nquis sunt voluptatem rerum illo velit&quot;
				},
				{
					&quot;userId&quot;: 1,
					&quot;id&quot;: 5,
					&quot;title&quot;: &quot;nesciunt quas odio&quot;,
					&quot;body&quot;: &quot;repudiandae veniam quaerat sunt sed\nalias aut fugiat sit autem sed est\nvoluptatem omnis possimus esse voluptatibus quis\nest aut tenetur dolor neque&quot;
				}
			]
		}
	}
}</code></pre>
		</div>
		<ui-table :items="items" container-class="box">
			<ui-table-column prop="id"/>
			<ui-table-column prop="title"/>
			<ui-table-column prop="body"/>
		</ui-table>
	</div>
</template>

<script>

    export default {
        name: "basic",
		props: {
            items: Array
		}
    }
</script>